import { camelize } from "humps";
import { ApiValidationError } from "PFTypes";
import { TFunction } from "react-i18next";

import { getAttribute } from "../get_attribute";

export type ErrorFormatOptions = {
  camelizeFieldNames?: boolean;
};

export const getErrorFieldName = (pointer) => {
  const name = pointer.replace(/^\/data\/attributes\//, "");
  if (name.indexOf("/") >= 0) {
    return `${name.replace("/", "[").replace(/\//g, "][")}]`;
  }
  return name;
};
export const getErrorName = (error: ApiValidationError, { camelizeFieldNames }: ErrorFormatOptions = {}) => {
  const errorKey = error?.source?.pointer ? getErrorFieldName(error.source.pointer) : error.title;
  return camelizeFieldNames ? camelize(errorKey) : errorKey;
};

export const getErrorMessage = (t: TFunction, error: ApiValidationError) => {
  const translationKey = getAttribute(error.meta, "translationKey");
  if (translationKey) {
    return t(camelize(translationKey) as unknown as TemplateStringsArray, {
      defaultValue: t(translationKey as unknown as TemplateStringsArray, { defaultValue: error.detail })
    });
  }

  return t((error.detail || "") as unknown as TemplateStringsArray, { defaultValue: error.detail || "" });
};
